/**
 * Permanent entitlement check: LaunchDarkly staff only.
 *
 * Cross-links between Vega chats and the observability conversation view must
 * never appear for customer accounts. Domain matching is the hard gate so a
 * flag rollout cannot accidentally expose the UI.
 */
export function isLaunchDarklyMemberEmail(email: string | null | undefined): boolean {
  return typeof email === 'string' && email.toLowerCase().endsWith('@launchdarkly.com');
}
